<!--
 * @Description: 实习就业管理 分配实习生 详情
 * @Author: PF
 * @Date: 2022-09-23 11:53:32
 * @LastEditors: PF
 * @LastEditTime: 2025-12-18 17:49:38
-->
<template>
  <div class="tan-chuang">
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border class="descript-box">
        <el-descriptions-item label="学期名称" label-align="right" align="left" width="135px" span="2">{{ruleForm.xqmc}}</el-descriptions-item>
        <el-descriptions-item label="学生" label-align="right" align="left" width="121px" span="2">{{ruleForm.xsxm}}</el-descriptions-item>
        <el-descriptions-item label="实习计划" label-align="right" align="left" span="4">{{ruleForm.sxjhmc}}</el-descriptions-item>
        <el-descriptions-item label="实习日期" label-align="right" align="left" span="4">{{ruleForm.sxksrq}} 至 {{ruleForm.sxjsrq}}</el-descriptions-item>
        <el-descriptions-item label="实习单位" label-align="right" align="left" span="4">{{ruleForm.sxdwmc}}</el-descriptions-item>
        <el-descriptions-item label="实习岗位" label-align="right" align="left" span="2">{{ruleForm.sxgw}}</el-descriptions-item>
        <el-descriptions-item label="薪资" label-align="right" align="left" span="2">{{ruleForm.xz}}</el-descriptions-item>
        <el-descriptions-item label="主管教师" label-align="right" align="left" span="2">{{ruleForm.zgjsxm}}</el-descriptions-item>
        <el-descriptions-item label="申请单位联系人" label-align="right" align="left" span="2">{{ruleForm.sqdwlxr}}</el-descriptions-item>
        <el-descriptions-item label="申请单位联系方式" label-align="right" align="left" span="4">{{ruleForm.sqdwlxfs}}</el-descriptions-item>
        <el-descriptions-item label="申请单位地址" label-align="right" align="left" span="4">{{ruleForm.sqdwdz}}</el-descriptions-item>
        <el-descriptions-item label="申请原因及承诺" label-align="right" align="left" span="4">{{ruleForm.sqyyjcn}}</el-descriptions-item>
        <el-descriptions-item label="审核状态" label-align="right" align="left" span="2">
          <span v-for="(item,index) in tjshztData.listZhuangTai" :key="index">
            <span v-if="ruleForm.zt ===item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="实习方式" label-align="right" align="left" span="2">
          <span v-for="(item,index) in sxfsData" :key="index">
            <span v-if="ruleForm.sxfs===item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="实习状态" label-align="right" align="left" span="2">
          <span v-for="(item,index) in sxztData.listZhuangTai" :key="index">
            <span v-if="ruleForm.sxzt ===item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="申请日期" label-align="right" align="left" span="2">{{ruleForm.sqrq}}</el-descriptions-item>
        <el-descriptions-item label="审批意见" label-align="right" align="left" span="4">{{ruleForm.spyj}}</el-descriptions-item>
        <el-descriptions-item label="" label-align="right" align="left" span=""></el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const ruleForm = ref({ jlgwxx: [{ sxgw: '', xz: '' }] })
const emits = defineEmits(['update:openDetail'])
// 实习方式
const sxfsData = ref()
// 实习状态
const sxztData = ref({ listZhuangTai: [] })
// 提交审核状态
const tjshztData = ref({ listZhuangTai: [] })
watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({
        url: '/api/v2/shixi/shixijilu/shixifangshi',
        data: sxfsData
      })
      loadSelect({
        url: '/api/v2/shixi/shixijilu/shixizhuangtai',
        data: sxztData
      })
      loadSelect({
        url: '/api/v2/shixi/shixijilu/shixitijiaoshenhe',
        data: tjshztData
      })
      loadData({
        url: '/api/v2/shixi/shixijilu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
